var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/searchnormal1",
    clipPath: "url(#clip0_3062_3837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 14.6668L13.3333 13.3335M7.66666 14.0002C8.49837 14.0002 9.32193 13.8363 10.0903 13.5181C10.8587 13.1998 11.5569 12.7333 12.145 12.1452C12.7331 11.5571 13.1996 10.8589 13.5179 10.0905C13.8362 9.3221 14 8.49853 14 7.66683C14 6.83512 13.8362 6.01156 13.5179 5.24317C13.1996 4.47477 12.7331 3.77659 12.145 3.18849C11.5569 2.60038 10.8587 2.13387 10.0903 1.81559C9.32193 1.49731 8.49837 1.3335 7.66666 1.3335C5.98696 1.3335 4.37605 2.00076 3.18832 3.18849C2.00059 4.37622 1.33333 5.98712 1.33333 7.66683C1.33333 9.34653 2.00059 10.9574 3.18832 12.1452C4.37605 13.3329 5.98696 14.0002 7.66666 14.0002Z",
    stroke: "#AAACAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3062_3837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.fa00a9806f96f21c440bc9f8bc478a11.svg";
export { ForwardRef as ReactComponent };